angular.module('rjmNg.directives').directive "emailInput", [
  () ->
    restrict: "E"
    templateUrl: "directive.emailInput.html"
    replace: false
    controllerAs: "view"
    bindToController: true
    scope:
      onUpdate: '&'
      initList: '<'
    controller: [
      "emailSummaryEnums"
      "KEY_CODES"
      (
        emailSummaryEnums
        KEY_CODES
      ) ->

        view = @

        view.input = ""
        view.emailPills = []
        view.textareaFocus = false
        view.pillsBlockFocus = false
        view.MAX_RECIPIENTS_NUMBER = emailSummaryEnums.MAX_RECIPIENTS_NUMBER

        _validateEmail = (email) ->
          return email isnt "" and
            email.length < emailSummaryEnums.MAX_EMAIL_LENGTH and
            emailSummaryEnums.EMAIL_REGEXP.test(email)

        _creatreEmailPill = (email) ->
          emailLowerCase = email.toLowerCase()
          return {
            email: emailLowerCase,
            isValid: _validateEmail(emailLowerCase)
            editing: false
            focused: false
          }

        _onUpdate = () ->
          result = view.emailPills.reduce(
            (acc, emailPill) ->
              # the initial value should be not valid when the reducing array
              # is empty and valid when we have elements in the array
              acc.isValid = (acc.emailList.length is 0 or acc.isValid) and
                emailPill.isValid
              acc.emailList.push(emailPill.email)
              return acc
            , {
              isValid: false
              emailList: []
            }
          )
          view.onUpdate(result)
          return

        _sanitizeEmail = (email) ->
          # remove backslashed characters
          tempEmail1 = email.replace(/\\(.{1})/g, '$1')
          if /^['"]+$/.test(tempEmail1)
            return ""
          else
            # remove leading quotes
            tempEmail2 = tempEmail1.replace(/^'*"{1}['"]*(.+)$/, '$1')
            # remove closing quotes
            resultEmail = tempEmail2.replace(/^('*[^'"]+)['"]+$/, '$1')
            return resultEmail.toLowerCase()

        _findInEmailPills = (email) ->
           return _.findIndex(view.emailPills, (emailPill) ->
               emailPill.email is email.toLowerCase()
             )

        _addToEmailPills = (email) ->
          if view.emailPills.length < view.MAX_RECIPIENTS_NUMBER
            view.emailPills.push(_creatreEmailPill(email))
          return

        view.editEmailPill = (emailPill, event) ->
          event.stopPropagation()
          emailPill.editing = true
          emailPill.focused = true
          return

        view.setTextareaFocus = () ->
          view.textareaFocus = true
          return

        view.setPillsBlockFocus = () ->
          view.pillsBlockFocus = true
          return

        view.setPillsBlockUnfocus = () ->
          view.pillsBlockFocus = false
          return

        view.removeEmailPill = (event, index) ->
          event.stopPropagation()
          view.emailPills.splice(index, 1)
          _onUpdate()
          return

        view.inputChange = (forced = false) ->
          emails = view.input.split(emailSummaryEnums.SPLIT_SYMBOLS_REGEXP)
          if emails.length > 1 or forced
            for email in emails
              sanitizedEmail = _sanitizeEmail(email)
              if (sanitizedEmail.length > 0 and
                _findInEmailPills(sanitizedEmail) is -1)
                  _addToEmailPills(sanitizedEmail)
            view.input = ""
            _onUpdate()
          return

        view.keydownTextarea = (event) ->
          event.stopPropagation()
          switch event.keyCode
            when KEY_CODES.ENTER then view.inputChange(true)
            when KEY_CODES.BACKSPACE then if view.input is ""
              view.emailPills.pop()
              _onUpdate()
          return

        view.keydownEmailPill = (emailPill, event) ->
          if event.keyCode is KEY_CODES.ENTER
            view.editEmailPill(emailPill, event)
          return

        view.keydownInputEmailPill = (emailPill, event, index) ->
          if event.keyCode is KEY_CODES.ENTER
            view.validateEmail(emailPill, event, index)
          return

        view.validateEmail = (emailPill, event, index) ->
          event.stopPropagation()
          email = event.target.value.replace(emailSummaryEnums.SPLIT_SYMBOLS_REGEXP, "")
          sanitizedEmail = _sanitizeEmail(email)
          # remove pill if the email is empty or duplicate
          if sanitizedEmail is "" or _findInEmailPills(sanitizedEmail) not in [-1, index]
            view.removeEmailPill(event, index)
          else if sanitizedEmail isnt emailPill.email
            view.emailPills[index] = _creatreEmailPill(sanitizedEmail)
            _onUpdate()
          else
            emailPill.editing = false
            event.target.value = sanitizedEmail
          view.setTextareaFocus()
          view.setPillsBlockFocus()
          return

        _init = () ->
          emailList = if Array.isArray(view.initList) then view.initList else []
          emailList = _.uniq(
            emailList.map((email) -> email.toLowerCase())
          )
          view.emailPills = emailList.map(_creatreEmailPill)
          view.input = ""
          _onUpdate()
          return

        view.$onChanges = (changesObj) ->
          unless angular.equals(
            changesObj.initList.currentValue
            changesObj.initList.previousValue
          )
            _init()
          return

        return view
    ]
]
